import classes from './Splitter.module.scss';

export const VerticalSplitter = ({ onClick }) => (
  <div className={classes.splitter}>
    <div className={classes.fab} onClick={onClick} />
  </div>
)